import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ApiCall } from "../../../../helper/axios";
import { fromUrlVendor } from "../../../../helper/vendorMask";

export const useGetCheckoutDetails = () => {
  const params = useParams();
  const queryParams = useLocation().search
  const query = new URLSearchParams(queryParams)
  const bookingId = query.get("bookingId")
  const vendor = fromUrlVendor(query.get("type"))
  const commonId = query.get("commonId")
  const detail = query.get("detail")
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [wpId, setWpId] = useState(null);
  const [priceBreakdown,setpriceBreakdown]=useState(null);
  const [mode, setMode] = useState("checkout");

  useEffect(() => {
    if (!params?.id) return;
    setDetails(null);
    if(bookingId){
      fetchBookingDetails()
    } else {
      fetchCheckoutDetails()
    }
  }, [params?.id,queryParams]);

  const fetchCheckoutDetails = async () => {
    try {
      setLoading(true);
      const response = await ApiCall(
        "GET",
        `/hotels/checkout-details?_id=${params.id}&commonId=${commonId}&vendor=${vendor}`
      );
      const data = response?.data?.data;
      if (data?.wpId) setWpId(data.wpId);
      setDetails(data);
      let prices = {
        ...data?.apiResponse?.priceBreakdown , onlineServiceFees : parseFloat(data?.apiRequestConfirmation?.onlineServiceFees)
      }
      setpriceBreakdown(prices)
    } catch (error) {
      console.error("Error fetching checkout details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBookingDetails = async () => {
    try {
      setLoading(true);
      const response = await ApiCall(
        "POST",
        `/hotels/booking-details`,
        {
          bookingId : bookingId,
          vendor,
          bookingRef : params?.id,
          fromDatabase : !!detail
        }
      );
      const data = response?.data?.data;
      if (data?.wpId) setWpId(data.wpId);
      setDetails(data);
    } catch (error) {
      console.error("Error fetching booking details:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    details,
    loading,
    wpId,
    setMode,
    refresh: fetchCheckoutDetails,
    getBookingDetails: fetchBookingDetails,
    priceBreakdown
  };
};
